/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from "react";
import ReactSelect, { components } from "react-select";
import PropTypes from "prop-types";
import { useWatchInput } from "../hooks/useWatchInput";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          readOnly
          aria-hidden="true"
          tabIndex={-1}
        />{" "}
        <span>{props.label}</span>
      </components.Option>
    </div>
  );
};

const toOptionArray = (value) =>
  value.map((location) => {
    if (location.location) {
      return {
        label: location.location,
        value: location.location
      };
    } else {
      return {
        label: location,
        value: location
      };
    }
  });

const MultipleLocationsSelector = (props) => {
  const { name, locations, selectedLocation, required, array_name, disableProps, ariaLabel } =
    props;

  const [value, setValue] = useState(selectedLocation ? toOptionArray(selectedLocation) : []);
  const [isDisabled, setIsDisabled] = useState(false);

  const inputValueToWatchForDisabling = useWatchInput({ id: disableProps && disableProps.id });

  useEffect(() => {
    if (inputValueToWatchForDisabling && inputValueToWatchForDisabling === disableProps.value)
      setIsDisabled(true);
    else setIsDisabled(false);
  }, [inputValueToWatchForDisabling]);

  const handleChange = (selected) => {
    setValue(selected);
  };

  const getValues = () => {
    return { locations: value.map((val) => val.value) };
  };

  const options = useMemo(() => toOptionArray(locations), [locations]);
  const array_value = useMemo(() => getValues(), [value]);

  return (
    <>
      <input type="hidden" name={array_name} value={!isDisabled && JSON.stringify(array_value)} />
      <ReactSelect
        aria-label={ariaLabel}
        options={options}
        isMulti
        id="user_locations"
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option
        }}
        required={required}
        name={name}
        onChange={handleChange}
        allowSelectAll={true}
        value={value}
        isDisabled={isDisabled}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            border: "1px solid #26547c",
            minHeight: "3.5rem",
            fontSize: "1.2rem",
            padding: "0 1.5rem",
            paddingLeft: "1rem",
            boxShadow: "inset 0 1px 2px rgb(0 0 0 / 10%)"
          })
        }}
      />
    </>
  );
};
Option.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
};
MultipleLocationsSelector.propTypes = {
  name: PropTypes.string.isRequired,
  locations: PropTypes.array.isRequired,
  selectedLocation: PropTypes.array.isRequired,
  disableProps: PropTypes.object,
  ariaLabel: PropTypes.string
};

MultipleLocationsSelector.defaultProps = {
  ariaLabel: "Locations"
};

export default MultipleLocationsSelector;
